import { NO_VALUE_PLACEHOLDER } from "src/constants";

import styles from "./TechnicalText.scss";

export type TechnicalTextProps = {
  children: string | null | undefined;
};

export function TechnicalText({ children }: TechnicalTextProps) {
  if (!children) {
    return NO_VALUE_PLACEHOLDER;
  }

  return <p className={styles.technicalText}>{children}</p>;
}
